/**
 * Main JS file for Paragon Underscores theme
 *
 * Will be compiled into js/main.js
 */

import { desktopNavigation } from './modules/desktopNavigation';
import { mobileNavigation } from './modules/mobileNavigation';
import { searchModal } from './modules/searchModal';
import { sidebarDropdown } from './modules/sidebarDropdown';

// run all functions on page load.
document.addEventListener('DOMContentLoaded', function () {
	desktopNavigation();
	mobileNavigation();
	searchModal();
	sidebarDropdown();
});
